import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const HeroSection = ({ title, subtitle, backgroundImage, height = '300px', children }) => {
  return (
    <Box
      sx={{
        background: backgroundImage
          ? `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${backgroundImage}) center/cover`
          : 'linear-gradient(135deg, #FF6F00 0%, #FFA040 50%, #FF6F00 100%)',
        minHeight: height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '60px',
          background: 'linear-gradient(transparent, rgba(255,248,240,1))',
        },
      }}
    >
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1, py: 4 }}>
        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontWeight: 800,
            mb: 2,
            fontSize: { xs: '2rem', md: '3rem' },
            textShadow: '0 2px 10px rgba(0,0,0,0.3)',
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant="h5"
            sx={{
              fontWeight: 400,
              opacity: 0.9,
              mb: 3,
              fontSize: { xs: '1.1rem', md: '1.4rem' },
            }}
          >
            {subtitle}
          </Typography>
        )}
        {children}
      </Container>
    </Box>
  );
};

export default HeroSection;
